import React from 'react'
import FontIcon from 'material-ui/FontIcon'
import shrinked from './shrinked'
import { AFFIDABILITA_ICON_NAME } from '../styles/icons'
import { themeColors } from '../styles/theme'

const styles = {
  bottomBar: {
    height: 50,
    backgroundColor: themeColors.lightBackground,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    padding: 4,
    fontSize: '14px',
    //lineHeight: '44px'
  },
  bottomBarItem: {
    flexGrow: 1,
    flexBasis: 0,
    textAlign: 'center',
  },
  bottomBarTitle: {
    fontSize: '10px',
    lineHeight: '10px',
    display: 'inline-block',
  },
  bottomBarValue: {
    display: 'block',
    marginTop: '-4px',
  },
  icons: {
    fontSize: 18,
    verticalAlign: 'middle',
    color: themeColors.positive,
  },
}

const UserBottomBar = ({ otherUser }) => {
  return (
    <div style={styles.bottomBar}>
      <div style={styles.bottomBarItem}>
        <span style={styles.bottomBarTitle}>Posizione</span>
        <div style={styles.bottomBarValue}>
          <FontIcon style={styles.icons} className="material-icons">
            place
          </FontIcon>
          {otherUser.district}
        </div>
      </div>
      <div style={styles.bottomBarItem}>
        <span style={styles.bottomBarTitle}>Affidabilità</span>
        <div style={styles.bottomBarValue}>
          <FontIcon style={styles.icons} className="material-icons">
            {AFFIDABILITA_ICON_NAME}
          </FontIcon>
          {Number(otherUser.affidabilita * 100).toFixed()}
          %
        </div>
      </div>
      <div style={styles.bottomBarItem}>
        <span style={styles.bottomBarTitle}>Scambi</span>
        <div style={styles.bottomBarValue}>
          <FontIcon style={styles.icons} className="material-icons">
            cached
          </FontIcon>
          {otherUser.transazioni}
        </div>
      </div>
    </div>
  )
}

export default shrinked(UserBottomBar, 'UserBottomBar')



// WEBPACK FOOTER //
// ./src/common/UserBottomBar.js